import { Component, ElementRef, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { EmpGroupFormDataService } from '../emp-group-form-data/emp-group-form-data.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ManageEmpGrpService, SharedConstant, SharedService } from '@ems/shared';
import { emtrConstant } from '../../../constants/emtrConstants';
import { EmtrService } from '../../../emtr.service';
import { BehaviorSubject, Observable, Observer } from 'rxjs';
import { DeleteConfirmationModalComponent } from '../../../delete-confirmation-modal/delete-confirmation-modal.component';

@Component({
  selector: 'tr-step2-add-employees',
  templateUrl: './step2-add-employees.component.html'
})
export class Step2AddEmployeesComponent implements OnInit, OnDestroy {

  getConstant = emtrConstant;
  getSharedConstant = SharedConstant;
  employeeGroups: any[] = [];
  employeeAccounts: any[] = [];
  addEmployeeFormData: any;
  selectedValues: any;
  initialLoad = true;
  message: any;
  noOfRecords: any = 15;
  cancelButton = true;
  selectedArr: any = [];
  selectedArrAccount: any = [];
  orgId = '';
  employees: any[];
  empIds: any[] = [];
  subAccNumbers: any[] = [];
  ruleType: string;
  parent = 0;
  child = 0;
  localObserver: any;
  confirmMessage: any;
  setPreviousStep = false;
  param = {
    orgId: '',
    pageNumber: 1,
    pageSize: 1,
    sortField: ''
  };
  is10b5Client = false;
  loadedModuleType = 'EmployeeGroup';
  mergedArr: any[];
  isEmitted: any = false;
  subAccntNumbers: any[] = [];
  newlyAssignedEmployeeAccounts: any = {};
  modifiedSelectedRecords: any = {};
  businessUnit: any;
  initialEditGroupAssignInfoData: any = [];
  changesInCurrentSession = false;
  previousSelection: any[] = [];
  @ViewChild('confirmationMessage', { static: true }) confirmationMessage: any;
  @ViewChild('uploadList', { static: false }) uploadList: ElementRef;
  @ViewChild(DeleteConfirmationModalComponent) editMasterGroupConfirmationModal: DeleteConfirmationModalComponent;
  invalidErrorMessage = new BehaviorSubject<string>('');

  constructor(public sharedService: SharedService, public formDataService: EmpGroupFormDataService, private router: Router, private r: ActivatedRoute, private manageEmpService: ManageEmpGrpService, public emtrService: EmtrService,
      @Inject('entitlementConst') public entitlementConst,) {
    this.addEmployeeFormData = { ...this.formDataService.getFormData() };
    this.sharedService.clientInformation.subscribe(clientInfo => {
      if (clientInfo) {
        this.businessUnit = this.sharedService.groupType === this.getSharedConstant.manageMasterGroups.groupTypeMGP ? this.sharedService.groupType : clientInfo.businessUnit;
        this.loadedModuleType = this.sharedService.groupType === this.getSharedConstant.manageMasterGroups.groupTypeMGP ? this.sharedService.groupType : 'EmployeeGroup';
      }
    });
  }

  ngOnInit() {
    this.orgId = this.manageEmpService.orgId;
    if (this.addEmployeeFormData.employeeGroupAssignInfo.employeeAccounts) {
      this.selectedArr = this.addEmployeeFormData.employeeGroupAssignInfo.employeeAccounts ? [...this.addEmployeeFormData.employeeGroupAssignInfo.employeeAccounts] : [];
      this.empIds = this.addEmployeeFormData.employeeGroupAssignInfo.empIds ? [...this.addEmployeeFormData.employeeGroupAssignInfo.empIds] : [];
      this.subAccNumbers = this.addEmployeeFormData.employeeGroupAssignInfo.subAccNumbers ? [...this.addEmployeeFormData.employeeGroupAssignInfo.subAccNumbers] : [];
      if (this.loadedModuleType === 'EmployeeGroup' && this.addEmployeeFormData.mode === 'EDIT') {
        this.initialEditGroupAssignInfoData = this.addEmployeeFormData.employeeGroupAssignInfo ? { ...this.addEmployeeFormData.employeeGroupAssignInfo } : [];
      }
    }
    this.confirmMessage = this.confirmationMessage.confirmMessage;
    this.confirmMessage.message = this.getConstant.rulesConstant.confirmationMessage.menuClickMsg;
    this.sharedService.schErrorMsg.subscribe(value => {
      this.emtrService.schErrorMsg.emit(value);
      if (value.length > 0) {
        this.emtrService.showSchError.emit(true);
      } else {
        this.emtrService.showSchError.emit(false);
      }
    });
    this.is10b5Client = this.sharedService.get10b5ClientDetails();
  }

  modifySelectedArray() {
    if (this.addEmployeeFormData.employeeGroupAssignInfo.newSelectedRecords && this.addEmployeeFormData.employeeGroupAssignInfo.newSelectedRecords.length) {
      this.addEmployeeFormData.employeeGroupAssignInfo.newSelectedRecords.forEach(newSel => {
        if ((this.selectedArr.findIndex((sele: any) => this.sharedService.isSameEmployeeRecord(newSel, sele)) === -1)) {
          this.selectedArr.push(newSel);
        }
      });
    }

    if (this.addEmployeeFormData.employeeGroupAssignInfo.removedExistingSelected && this.addEmployeeFormData.employeeGroupAssignInfo.removedExistingSelected.length) {
      this.addEmployeeFormData.employeeGroupAssignInfo.removedExistingSelected.forEach(remSel => {
        const remIdx = this.selectedArr.findIndex((sele: any) => this.sharedService.isSameEmployeeRecord(remSel, sele));
        if (remIdx !== -1) {
          this.selectedArr.splice(remIdx, 1);
        }
      });
    }
  }

  canDeactivate(event, observer) {
    this.confirmMessage.message = (this.confirmMessage.message !== undefined && this.confirmMessage.message) ? this.confirmMessage.message : this.getConstant.rulesConstant.confirmationMessage.menuClickMsg;
    if ((this.cancelButton && this.addEmployeeFormData.mode === 'EDIT') || (this.cancelButton && this.addEmployeeFormData.mode !== 'EDIT' && (this.selectedArrAccount.length > 0 || this.selectedArr.length > 0))) {
      this.localObserver = observer;
      return this.confirmationMessage.showConfirmMsg(this.confirmMessage, observer);
    }
    return true;
  }

  storePageInfo(type) {
    if (this.addEmployeeFormData.mode === 'EDIT') {
      this.mergedArr = this.isEmitted ? this.selectedArr : this.addEmployeeFormData.employeeGroupAssignInfo.employeeAccounts;
    } else {
      this.mergedArr = this.selectedArr;
    }
    const wholeArray = this.mergedArr;
    const localSelectedItem = this.sharedService.setSelectionItem(wholeArray);

    let formObj = {};
    if (this.loadedModuleType === 'EmployeeGroup' && this.addEmployeeFormData.mode === 'EDIT') {
      this.modifiedSelectedRecords.assignEmpIds = [];
      this.modifiedSelectedRecords.assignSubAcctNumbers = [];
      this.modifiedSelectedRecords.unAssignEmpIds = [];
      this.modifiedSelectedRecords.unAssignSubAcctNumbers = [];
      if (this.newlyAssignedEmployeeAccounts.newSelectedRecords && this.newlyAssignedEmployeeAccounts.newSelectedRecords.length) {
        this.newlyAssignedEmployeeAccounts.newSelectedRecords.forEach(newSel => {
          if (newSel.empId && newSel.parent && !this.modifiedSelectedRecords.assignEmpIds.includes(newSel.empId)) {
            this.modifiedSelectedRecords.assignEmpIds.push(newSel.empId);
          }
          if (!newSel.parent && newSel.child) {
            this.modifiedSelectedRecords.assignSubAcctNumbers.push({ empId: newSel.empId || '', subAcctNum: newSel.subAcctNum });
          }
        });
      }
      if (this.newlyAssignedEmployeeAccounts.removedExistingSelected && this.newlyAssignedEmployeeAccounts.removedExistingSelected.length) {
        this.newlyAssignedEmployeeAccounts.removedExistingSelected.forEach(remSel => {
          if (remSel.empId && remSel.empLevelGroupIds && (remSel.empLevelGroupIds.indexOf(this.addEmployeeFormData.id) !== -1) && !this.modifiedSelectedRecords.unAssignEmpIds.includes(remSel.empId)) {
            this.modifiedSelectedRecords.unAssignEmpIds.push(remSel.empId);
          }
          if (remSel.groupIds && remSel.groupIds.indexOf(this.addEmployeeFormData.id) !== -1) {
            this.modifiedSelectedRecords.unAssignSubAcctNumbers.push({ empId: remSel.empId || '', subAcctNum: remSel.subAcctNum });
          }
        })
      }
      /* When employee account numbers are hidden, an employee assignment/unassignment must be sent at the employee level (empIds) instead of the account level (subAcctNumbers). */
      const shouldHideEmployeeAccountNumbers = this.sharedService.checkForVisibilityAccount();
      if (shouldHideEmployeeAccountNumbers) {
        this.modifiedSelectedRecords = this.moveSubAccountSelectionsToEmployeeIds(this.modifiedSelectedRecords, 'assignSubAcctNumbers', 'assignEmpIds');
        this.modifiedSelectedRecords = this.moveSubAccountSelectionsToEmployeeIds(this.modifiedSelectedRecords, 'unAssignSubAcctNumbers', 'unAssignEmpIds');
      }
    }

    if (this.addEmployeeFormData.mode === 'EDIT') {
      formObj = {
        empIds: this.setPreviousStep ? [] : this.empIds,
        subAccntNumbers: this.setPreviousStep ? [] : this.subAccntNumbers,
        employeeAccounts: this.mergedArr,
        newSelectedRecords: this.newlyAssignedEmployeeAccounts.newSelectedRecords,
        removedExistingSelected: this.newlyAssignedEmployeeAccounts.removedExistingSelected,
        assignEmpIds: this.modifiedSelectedRecords.assignEmpIds,
        assignSubAcctNumbers: this.modifiedSelectedRecords.assignSubAcctNumbers,
        unAssignEmpIds: this.modifiedSelectedRecords.unAssignEmpIds,
        unAssignSubAcctNumbers: this.modifiedSelectedRecords.unAssignSubAcctNumbers,
        subAccntNewlySelected: this.newlyAssignedEmployeeAccounts.subAccntNewlySelected,
        removedExistingEmpId: this.newlyAssignedEmployeeAccounts.removedExistingEmpId,
      };
    } else {
      const empIds = [];
      this.selectedArr.forEach(item => {
        if (item.parent && item.child) {
          (item.empId && !empIds.includes(item.empId)) ? empIds.push(item.empId) : '';
        }
      });
      this.empIds = empIds;
      formObj = {
        empIds: this.empIds,
        subAccntNumbers: this.subAccNumbers,
        employeeAccounts: this.mergedArr
      };
    }
    if (type === 'falseStep2') {
      if (this.loadedModuleType === 'EmployeeGroup' && this.addEmployeeFormData.mode === 'EDIT') {
        this.sharedService.isPreviousBtnClickedOnEdit = true;
        this.sharedService.empGrpStep2InitialEmpData = this.initialEditGroupAssignInfoData.newSelectedRecords ? [...this.initialEditGroupAssignInfoData.newSelectedRecords] : [];
      } else {
        this.sharedService.empGrpStep2InitialEmpData = this.addEmployeeFormData.employeeGroupAssignInfo.employeeAccounts ? [...this.addEmployeeFormData.employeeGroupAssignInfo.employeeAccounts] : [];
      }
      this.formDataService.setStep2(formObj, false);
    } else {
      this.sharedService.isPreviousBtnClickedOnEdit = false;
      this.formDataService.setStep2(formObj, true);
    }
  }

  goToPreviousStep() {
    this.setPreviousStep = true;
    this.cancelButton = false;
    if (this.addEmployeeFormData.mode === 'EDIT' && this.sharedService.groupType === this.getSharedConstant.manageMasterGroups.groupTypeMGP ) {
      this.sharedService.changesMadeInEditMGPStep2 = this.hasMasterAccountModifications();
    }
    this.storePageInfo('falseStep2');
    this.navigateTo('../step1');
  }

  goToNextStep() {
    this.storePageInfo('');
    this.cancelButton = false;
    this.sharedService.empGrpStep2InitialEmpData = [];
    this.navigateTo('../step3');
  }

  navigateTo(path) {
    this.router.navigate([path], { relativeTo: this.r });
  }

  cancelCreateEmpGroup() {
    this.confirmMessage.message = this.getConstant.rulesConstant.confirmationMessage.cancelBtnClickMsg;
    this.router.navigate([this.getSharedConstant[this.businessUnit].toLandingPage]);
  }

  uploadEmployeeList() {
    this.sharedService.clearErrorMessage();
    /* To update the pagename when bulk upload btn is clicked. */
    this.confirmMessage.message = this.getConstant.rulesConstant.confirmationMessage.menuClickMsg;
    this.sharedService.loadDataTrackValue('client_redirect');
    const employeeAccounts = this.addEmployeeFormData.employeeGroupAssignInfo.employeeAccounts || [];
    this.cancelButton = this.compareEmployeeObj(this.selectedArr, [...employeeAccounts]) ? false : true;
    this.sharedService.parentPage = '/empgroups';
    this.sharedService.isMGPBulkUpload = this.sharedService.groupType === this.getSharedConstant.manageMasterGroups.groupTypeMGP;
    const bulkUploadRoute = this.sharedService.groupType === this.getSharedConstant.manageMasterGroups.groupTypeMGP
      ? this.getSharedConstant.MGP.groupOrPlanBulkUploadRoute
      : this.getSharedConstant[this.businessUnit].groupOrPlanBulkUploadRoute;
    this.router.navigate([bulkUploadRoute]);
  }

  compareEmployeeObj(arr1, arr2) {
    /*To compare selectedArr array with its previous value in order to check whether any changes are made in edit flow */
    let flag = false;
    if (arr1.length !== arr2.length) {
      return flag;
    }
    for (let index = 0; index < arr1.length; index++) {
      const val = arr1[index];
      if ((arr2.findIndex(ele => ele.empId === val.empId && ele.subAcctNum === val.subAcctNum) === -1)) {
        flag = false;
        break;
      } else {
        flag = true;
      }
    }
    return flag;
  }

  updateSelectedArray(e) {
    if (this.initialLoad) {
      this.selectedValues = e;
      this.initialLoad = false;
      this.previousSelection = [...(e || [])];
    } else {
      // Use sharedService.checkChanges to detect real add/remove changes for edit mode of MGP
      if (this.sharedService.groupType === this.getSharedConstant.manageMasterGroups.groupTypeMGP && this.addEmployeeFormData.mode === 'EDIT') {
        const selectionDiff = this.sharedService.checkChanges(e || [], [...this.previousSelection], this.empIds || []);
        const addedOrRemovedData = (selectionDiff?.extraData?.length || 0) > 0 ||
          (selectionDiff?.removedData?.length || 0) > 0 ||
          (this.previousSelection.length !== e?.length);
        if (addedOrRemovedData) {
          this.changesInCurrentSession = true;
          this.previousSelection = [...e];
        }
      }
    }
    this.selectedArr = e;
    this.isEmitted = true;
  }

  updateNewlySelectedArray(e) {
    this.newlyAssignedEmployeeAccounts = e;
    const assignedData = this.sharedService.setSelectionItem(e.newSelectedRecords);
    let finalLocalUnselected;
    let multipEmployeeSelection;
    let empIdAlreadyRemoved;
    if (e.removedExistingSelected && e.removedExistingSelected.length > 0) {
      const localFinalLocalUnselected = this.sharedService.setSelectionItem(e.removedExistingSelected);
      finalLocalUnselected = localFinalLocalUnselected ? localFinalLocalUnselected : [];
    }

    if (e.subAccntNewlySelected && e.subAccntNewlySelected.length > 0) {
      const localMultipEmployeeSelection = this.sharedService.setSelectionItem(e.subAccntNewlySelected);
      multipEmployeeSelection = localMultipEmployeeSelection ? localMultipEmployeeSelection : [];
    }

    if (e.removedExistingEmpId && e.removedExistingEmpId.length > 0) {
      const localEmpIdAlreadyRemoved = this.sharedService.setSelectionItem(e.removedExistingEmpId);
      empIdAlreadyRemoved = localEmpIdAlreadyRemoved ? localEmpIdAlreadyRemoved : [];
    }
    this.modifiedSelectedRecords = {
      assignEmpIds: this.sharedService.removeDuplicates(this.sharedService.formData(assignedData, multipEmployeeSelection, 'empIds')),
      assignSubAcctNumbers: this.sharedService.removeDuplicates(this.sharedService.formData(assignedData, multipEmployeeSelection, 'subAccntNumbers')),
      unAssignEmpIds: this.sharedService.removeDuplicates(this.sharedService.formData(finalLocalUnselected, empIdAlreadyRemoved, 'empIds')),
      unAssignSubAcctNumbers: (finalLocalUnselected !== undefined) ? this.sharedService.removeDuplicates(finalLocalUnselected.subAccntNumbers) : [],
    };
  }

  updateSelectedAccountsArray(e) {
    this.selectedArrAccount = e;
  }

  /* Move employee-level selections (those with an empId) to the empId bucket and retain pure account-level selections in the sub-account bucket. */
  moveSubAccountSelectionsToEmployeeIds(records, subAcctKey, empKey) {
    const subAccountSelections = records[subAcctKey];
    if (!subAccountSelections?.length) {
      return records;
    }
    records[empKey] = records[empKey] || [];
    const existingEmpIds = new Set(records[empKey]);
    subAccountSelections.forEach(({ empId }: { empId: string }) => {
      if (empId && !existingEmpIds.has(empId)) {
        records[empKey].push(empId);
        existingEmpIds.add(empId);
      }
    });
    /* Keep account-level selections (records without an empId) in the sub-account bucket. */
    records[subAcctKey] = subAccountSelections.filter(({ empId }: { empId: string }) => !empId);
    return records;
  }

  ngOnDestroy(): void {
    this.sharedService.clearValidationFields();
    this.sharedService.selectedAllInfo.next('');
    this.invalidErrorMessage.next('');
  }

  /* Confirmation popup for Employee which has multiple accounts (Joint account) */
  confirmationPopup() {
    if (this.sharedService.groupType === this.getSharedConstant.manageMasterGroups.groupTypeMGP && this.addEmployeeFormData.mode === 'EDIT') {
      // Check if there are modifications for employee/participant groups in edit mode
      if (!this.changesInCurrentSession && this.sharedService.changesMadeInEditMGPStep2 !== true) {
        // No modifications detected in current Step 2 session, proceed directly to next step
        this.goToNextStep();
        return;
      }
      const hasModifications = this.hasMasterAccountModifications();
      if (hasModifications) {
        this.editMasterGroupConfirmationModal.openModal(this.addEmployeeFormData);
       return
      } else {
        // No modifications detected, proceed directly to next step
        this.goToNextStep();
        return
      }
    } else {
      let initialEmpData = [];
      let checkData;
      let isAllDataSelected = false;
      if (this.loadedModuleType === 'EmployeeGroup' && this.addEmployeeFormData.mode === 'EDIT') {
        initialEmpData = this.sharedService.isPreviousBtnClickedOnEdit ? (this.sharedService.empGrpStep2InitialEmpData || []) : (this.initialEditGroupAssignInfoData.newSelectedRecords || []);
        checkData = this.sharedService.checkChanges(this.newlyAssignedEmployeeAccounts.newSelectedRecords || [], [...initialEmpData], this.empIds);
        const initialRemovedExistingData = this.initialEditGroupAssignInfoData.removedExistingSelected || [];
        const currentRemovedExistingData = this.newlyAssignedEmployeeAccounts.removedExistingSelected || [];
        if (initialRemovedExistingData && currentRemovedExistingData && initialRemovedExistingData.length > currentRemovedExistingData.length) {
          currentRemovedExistingData.forEach(ele => (ele.empId && (checkData.extraEmpIds.indexOf(ele.empId) !== -1)) ? checkData.extraEmpIds.splice(checkData.extraEmpIds.indexOf(ele.empId), 1) : '');
          const againSelectedAlreadyRemoved = initialRemovedExistingData.filter(initialEle =>
            (currentRemovedExistingData.findIndex(currentEle => currentEle.empId === initialEle.empId && currentEle.subAcctNum === initialEle.subAcctNum) === -1));
          againSelectedAlreadyRemoved.forEach(ele => (ele.empId && !checkData.extraEmpIds.includes(ele.empId)) ? checkData.extraEmpIds.push(ele.empId) : '');
        }
        isAllDataSelected = this.sharedService.totalEmployeeRecords.allEmployeeRecords === (this.sharedService.totalEmployeeRecords.totalSelectedRecords + (this.newlyAssignedEmployeeAccounts.newSelectedRecords?.length || 0) - (this.newlyAssignedEmployeeAccounts.removedExistingSelected?.length || 0))
      } else {
        initialEmpData = this.sharedService.empGrpStep2InitialEmpData.length ? this.sharedService.empGrpStep2InitialEmpData : this.addEmployeeFormData.employeeGroupAssignInfo.employeeAccounts;
        checkData = this.sharedService.checkChanges(this.selectedArr, [...initialEmpData], this.empIds);
        isAllDataSelected = this.selectedArr.length === this.sharedService.totalEmployeeRecords.allEmployeeRecords;
      }
      const payload = {
        empIdList: checkData.extraEmpIds
      };
      if (!isAllDataSelected && ((checkData.extraData.length && checkData.extraEmpIds.length) ||
        (checkData.extraEmpIds.length && this.addEmployeeFormData.mode === 'EDIT'))) {
        const confirmObj = {
          header: this.getSharedConstant.confirmationDialog.accountSelectionConfirmationTitle,
          message: this.getSharedConstant.employeeAccountSelectionMessage,
          acceptBtn: this.getSharedConstant.confirmationDialog.acceptBtn,
          rejectBtn: this.getSharedConstant.confirmationDialog.rejectBtn,
          closeIconButton: false,
          disableRejectBtn: this.sharedService.hasUIVisibilityExclusionAction(this.getSharedConstant.visibilityUIComponents.employeeGroupStep2AcctCnslNoButton, 'DISABLE', 'employee')
        };
        new Observable((observer: Observer<boolean>) => {
          this.confirmationMessage.showConfirmMsg(confirmObj, observer);
        }).subscribe(accept => {
          if (accept) {
            if (this.addEmployeeFormData.mode === 'EDIT') {
              this.assignAndUnassignEmployees(true, checkData);
            } else {
              this.addAccountsToEmployeeArray(payload, checkData);
            }
          } else {
            if (this.addEmployeeFormData.mode === 'EDIT') {
              this.assignAndUnassignEmployees(false, checkData);
            } else {
              this.empIds = checkData.updatedEmpIds;
              this.updateSubAccNumbers(checkData.updatedEmpIds);
              this.goToNextStep();
            }
          }
        });
      } else {
        if (this.addEmployeeFormData.mode === 'EDIT') {
          this.assignAndUnassignEmployees(false, checkData);
        } else {
          this.empIds = checkData.updatedEmpIds;
          this.updateSubAccNumbers(checkData.updatedEmpIds);
          this.goToNextStep();
        }
      }
    }
  }

  /* Update the subaccount Number array for payload */
  updateSubAccNumbers(updatedEmpIds) {
    this.selectedArr.forEach(ele => {
      if (!ele.empId || (ele.empId && !updatedEmpIds.includes(ele.empId))) {
        this.subAccNumbers.push({ empId: ele.empId || '', subAcctNum: ele.subAcctNum });
        ele.parent = false;
        ele.child = true;
      }
    });
  }

  /* API call for empIds to get the all linked accounts */
  addAccountsToEmployeeArray(payload, data) {
    this.empIds = data.allEmpIds;
    this.selectedArr.forEach(ele => {
      !ele.empId ? this.subAccNumbers.push({ empId: ele.empId || '', subAcctNum: ele.subAcctNum }) : '';
      if (data.removedEmpIds && data.removedEmpIds.length && data.removedEmpIds.includes(ele.empId)) {
        this.subAccNumbers.push({ empId: ele.empId || '', subAcctNum: ele.subAcctNum });
        ele['parent'] = false;
      }
    });
    /* new API call then */
    this.sharedService.getEmployeeList({ pageNo: 0, pageSize: 500 }, payload, null, null, null, this.addEmployeeFormData.mode ?  this.addEmployeeFormData.mode : 'CREATE').subscribe((response) => {
      const data = response.data ? response.data.content : response.data;;
      data.forEach(element => {
        const hideEmployee = (element.subAcctNum || '').includes('*');
        const empIdx = this.selectedArr.findIndex((sel: any) => this.sharedService.isSameEmployeeRecord(element, sel));

        if (empIdx === -1) {
          element.parent = true;
          element.child = true;
          element.selectedEmployee = true;
          this.selectedArr.push(element);
          return;
        }

        this.selectedArr[empIdx].parent = true;
        element.selectedEmployee = true;
        if (!hideEmployee) {
          this.selectedArr[empIdx].child = true;
        }
      });
      this.goToNextStep();
    });
  }

  assignAndUnassignEmployees(empLevel, checkData) {
    this.empIds = empLevel ? checkData.extraEmpIds : [];
    checkData.extraData.forEach(emp => {
      const subAct = this.subAccntNumbers.findIndex(subAcct => subAcct.subAcctNum === emp.subAcctNum);
      if (subAct === -1 && (!emp.empId || (emp.empId && !empLevel))) {
        this.subAccntNumbers.push({empId: emp.empId || '', subAcctNum: emp.subAcctNum});
      }
    });

    this.selectedArr.forEach(ele => {
      if (checkData.removedEmpIds && checkData.removedEmpIds.length && checkData.removedEmpIds.includes(ele.empId)) {
        ele['parent'] = false;
      }
    });

    const unassignedSubAccts = [];
    const unassignedEmpIds = [];
    checkData.removedData.forEach(emp => {
      unassignedSubAccts.push({ empId: emp.empId || '', subAcctNum: emp.subAcctNum });
      if (emp.empId && emp.empLevelGroupIds && emp.empLevelGroupIds.indexOf(this.addEmployeeFormData.id) !== -1) {
        !unassignedEmpIds.includes(emp.empId) ? unassignedEmpIds.push(emp.empId) : '';
      }
    });

    if (empLevel) {
      const payload = {
        empIdList: checkData.extraEmpIds
      }
      /* new API call then */
      this.sharedService.getEmployeeList({ pageNo: 0, pageSize: 500 }, payload, null, null, null, this.addEmployeeFormData.mode ?  this.addEmployeeFormData.mode : 'CREATE').subscribe((response) => {
        const data = response.data ? response.data.content : response.data;;

        this.modifyAssignUnassignOnYes(data);
        this.goToNextStep();
      });
    } else {
      if (this.newlyAssignedEmployeeAccounts.newSelectedRecords && this.newlyAssignedEmployeeAccounts.newSelectedRecords.length) {
        checkData.extraData.forEach(extEle => {
          const newIdx = this.newlyAssignedEmployeeAccounts.newSelectedRecords.findIndex(newEle => newEle.empId === extEle.empId && newEle.subAcctNum === extEle.subAcctNum);
          if (newIdx !== -1) {
            this.newlyAssignedEmployeeAccounts.newSelectedRecords[newIdx]['parent'] = false;
            extEle['parent'] = false;
          }
        });
      }
      this.modifyAssignUnassignOnNo();
      this.goToNextStep();
    }
  }

  modifyAssignUnassignOnNo() {
    const initialNewlySelectedData = this.initialEditGroupAssignInfoData.newSelectedRecords || [];
    const currentNewlySelectedData = this.newlyAssignedEmployeeAccounts.newSelectedRecords || [];
    const empIdsToSetEmpLevelFalse = [];
    if (currentNewlySelectedData.length || initialNewlySelectedData) {
      initialNewlySelectedData.forEach(initialEle => {
        if (currentNewlySelectedData.findIndex(currentEle => currentEle.empId === initialEle.empId && currentEle.subAcctNum === initialEle.subAcctNum) === -1) {
          (initialEle.empId && this.empIds.includes(initialEle.empId)) ? this.empIds.splice(this.empIds.indexOf(initialEle.empId), 1) : '';
          empIdsToSetEmpLevelFalse.push(initialEle.empId);
        }
      });
      if (this.newlyAssignedEmployeeAccounts.removedExistingSelected && this.newlyAssignedEmployeeAccounts.removedExistingSelected.length) {
        this.newlyAssignedEmployeeAccounts.removedExistingSelected.forEach(exitEle => {
          if (currentNewlySelectedData.findIndex(currentEle => currentEle.empId === exitEle.empId && currentEle.subAcctNum === exitEle.subAcctNum) === -1) {
            (exitEle.empId && this.empIds.includes(exitEle.empId)) ? this.empIds.splice(this.empIds.indexOf(exitEle.empId), 1) : '';
            (exitEle.empId && !empIdsToSetEmpLevelFalse.includes(exitEle.empId)) ? empIdsToSetEmpLevelFalse.push(exitEle.empId) : '';
          }
        });
      }

      empIdsToSetEmpLevelFalse.forEach(empIdEle => {
        this.selectedArr.forEach(selEle => {
          if (selEle.empId === empIdEle) {
            selEle['parent'] = false;
          }
        });
        this.newlyAssignedEmployeeAccounts.newSelectedRecords.forEach(newEle => {
          if (newEle.empId === empIdEle) {
            newEle['parent'] = false;
          }
        });
      })
    }
  }

  modifyAssignUnassignOnYes(data) {
    data.forEach(dataEle => {
      const hideEmployee = (dataEle.subAcctNum || '').includes('*');
      const empIdx = this.selectedArr.findIndex((sel: any) => this.sharedService.isSameEmployeeRecord(dataEle, sel));
      if (empIdx === -1) {
        dataEle['parent'] = dataEle['child'] = dataEle['selectedEmployee'] = true;
        this.selectedArr.push(dataEle);
      } else {
        this.selectedArr[empIdx]['parent'] = true;
        if (!hideEmployee) {
          this.selectedArr[empIdx]['child'] = true;
        }
      }
      const eleIdx = this.newlyAssignedEmployeeAccounts.newSelectedRecords.findIndex((sel: any) => this.sharedService.isSameEmployeeRecord(dataEle, sel));
      const eleData = eleIdx !== -1 ? this.newlyAssignedEmployeeAccounts.newSelectedRecords[eleIdx] : null;
      if (!eleData && ((dataEle.groupIds && !dataEle.groupIds.includes(this.addEmployeeFormData.id)) || !dataEle.groupIds)) {
        dataEle['parent'] = dataEle['child'] = dataEle['selectedEmployee'] = true;
        this.newlyAssignedEmployeeAccounts.newSelectedRecords.push(dataEle);
      } else if (eleData) {
        eleData['parent'] = eleData['child'] = true;
        eleData['parent'] = eleData['child'] = eleData['selectedEmployee'] = true;
        this.newlyAssignedEmployeeAccounts.newSelectedRecords[eleIdx] = eleData;
      }
      const rmEleIdx = this.newlyAssignedEmployeeAccounts.removedExistingSelected.findIndex((sel: any) => this.sharedService.isSameEmployeeRecord(dataEle, sel));
      if (rmEleIdx !== -1) {
        this.newlyAssignedEmployeeAccounts.removedExistingSelected.splice(rmEleIdx, 1);
      }
    });
    this.newlyAssignedEmployeeAccounts.removedExistingSelected.forEach(existEle => {
      this.selectedArr.forEach(selEle => {
        if (selEle.empId === existEle.empId) {
          selEle['parent'] = false;
        }
      });
    });
  }
  verifyEntitlement(): boolean {
    const isOpenBrokerage = this.addEmployeeFormData?.subType === this.getSharedConstant.openBrokerage.subType;
    const isMasterGroup = this.sharedService.groupType === this.getSharedConstant.manageMasterGroups.groupTypeMGP;
    if (isOpenBrokerage && isMasterGroup) {
      this.sharedService.selectedAllInfo.next('All');
      return this.sharedService.checkEntitlements(this.entitlementConst.navUUID.ngOMS.manageMasterGroupOBP.uuid, '', '') &&
        this.sharedService.checkEntitlements(this.entitlementConst.navUUID.emtrAccess.manageMasterAccountGroup.uuid, '', '');
    }
    return true;
  }

  /* Check if there are modifications to master accounts (additions or removals) */
  hasMasterAccountModifications(): boolean {
    // Check if user has made any changes in current session
    if (!this.changesInCurrentSession && this.sharedService.changesMadeInEditMGPStep2 !== true) {
      return false;
    }
    const hasCurrentNewSelections = this.newlyAssignedEmployeeAccounts?.newSelectedRecords?.length > 0;
    const hasCurrentRemovals = this.newlyAssignedEmployeeAccounts?.removedExistingSelected?.length > 0;
    // Only return true if there are modifications made in this current Step 2 session
    return hasCurrentNewSelections || hasCurrentRemovals;
  }

  // to validate master group name on click of proceed button in modal
  validateMasterGroupName(groupName){
    if (this.addEmployeeFormData.name === groupName){
      this.sharedService.closeModal('delete-confirmation-modal');
      this.goToNextStep();
    }
    else {
      this.invalidErrorMessage.next(this.getSharedConstant.MGP.editStep2.incorrectMasterGrpNameText);
    }
  }

}
